import {PresetSchemaKind} from "platformed-client/types";
import {platformedClient} from "..";

// JSON Schema for the payload accepted by an internal create-from-preset
// endpoint, keyed by entity kind. Drives live validation in the upload UI.
export async function get(kind: PresetSchemaKind): Promise<Record<string, unknown>> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/preset_schemas/{kind}", {path: {kind}});
}
